// KeyboardIcon.tsx

import React from "react";

type KeyboardIconProps = React.SVGProps<SVGSVGElement> & {
  strokeColor?: string;
};

export const KeyboardIcon: React.FC<KeyboardIconProps> = ({ strokeColor, ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <g clipPath="url(#clip0_keyboard)">
        <path
          d="M4.00016 6.66667V6.67333M6.66683 6.66667V6.67333M9.3335 6.66667V6.67333M12.0002 6.66667V6.67333M4.00016 9.33333V9.34M12.0002 9.33333V9.34M6.66683 9.33333L9.3335 9.34M1.3335 5.33333C1.3335 4.97971 1.47397 4.64057 1.72402 4.39052C1.97407 4.14048 2.31321 4 2.66683 4H13.3335C13.6871 4 14.0263 4.14048 14.2763 4.39052C14.5264 4.64057 14.6668 4.97971 14.6668 5.33333V10.6667C14.6668 11.0203 14.5264 11.3594 14.2763 11.6095C14.0263 11.8595 13.6871 12 13.3335 12H2.66683C2.31321 12 1.97407 11.8595 1.72402 11.6095C1.47397 11.3594 1.3335 11.0203 1.3335 10.6667V5.33333Z"
          stroke={strokeColor ?? "#707087"}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      <defs>
        <clipPath id="clip0_keyboard">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
